import { render, staticRenderFns } from "./PlanningAssistant.vue?vue&type=template&id=3c438e5b&scoped=true&"
import script from "./PlanningAssistant.vue?vue&type=script&lang=js&"
export * from "./PlanningAssistant.vue?vue&type=script&lang=js&"
import style0 from "./PlanningAssistant.vue?vue&type=style&index=0&id=3c438e5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c438e5b",
  null
  
)

export default component.exports